import { Link } from 'react-router';
import { ROUTES } from '@/shared/config/routes';
import { Button } from '@/shared/ui/button';
import { Wordmark } from '@/shared/ui/wordmark';

export function NotFoundPage() {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-6 bg-bg px-5 text-center">
      <Wordmark />
      <div className="flex flex-col gap-2">
        <h1 className="font-semibold text-title">This page does not exist</h1>
        <p className="text-muted">The link may be old, or it was typed with a mistake.</p>
      </div>
      <Button asChild variant="primary">
        <Link to={ROUTES.OVERVIEW}>Go to Overview</Link>
      </Button>
    </main>
  );
}
